import moment, { Moment } from "moment";

export function formatDate(dateString : string){   
    if(!dateString) return '';
    var date = new Date(dateString);
    return `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
}

export function formatTime(dateString : string){  
    if(!dateString) return '';
    var date = new Date(dateString);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var minutesStr = minutes < 10 ? '0'+minutes : minutes;
    return `${hours}:${minutesStr} ${ampm}`;
}

export function formatTimeOnly(timeString: string){
    if(!timeString) return '';
    let [hours, minutes] = timeString.split(":");
    let hoursNumber = +hours % 12 ? +hours % 12 : 12;
    let ampm = +hours >= 12 ? 'PM' : 'AM';
    return `${hoursNumber}:${minutes} ${ampm}`
}

export function formatTimeFromDateTime(dateTimeString: string){
    if(!dateTimeString) return '';
    const timePart = dateTimeString.split('T')[1];
    if(!timePart) return '';
    return formatTimeOnly(timePart);
}

export const formatDateTime = (dateString: string, format: string | undefined) =>{
    if(!dateString) return '';
    switch(format){
        case 'hh:mm tt' : return moment().format('hh:mm A');
        case 'HH:mm' : return moment().format('hh:mm');
        case 'HH:mm:ss' : return moment().format('hh:mm:ss');
        case 'hh:mm:ss tt' : return moment().format('hh:mm:ss A');
        case 'hh/mm/ss tt, dd/MM/yyyy' : return moment().format('hh/mm/ss A, DD/MM/YYYY');
        case 'f' : return moment().format('dddd, MMMM D, YYYY hh:mm A');
        case 'F' : return moment().format('dddd, MMMM D, YYYY hh:mm:ss A');
        case 'HH:mm:ss, dd.MM.yyyy' : return moment().format('HH:mm:ss, DD.MM.YYYY');
    }
} 

export const currentDateString = () => {
    const yourDate = new Date()
    return yourDate.toISOString().split('T')[0];     
}

export const currentDateTimeString= () => {
    const now = new Date()
    return dateTimeString(now);
}

export const currentDateTimeStringLocale= () => {
    const now = new Date();
    let newDate = new Date(now.getTime() - now.getTimezoneOffset()*60*1000);
    return dateTimeString(newDate);
}

export const dateTimeString = (date: Date) => {
    return date.toISOString().slice(0,16);
}

export const getDateBefore = (days: number) => {
    var now = new Date();
    return new Date(now.getTime() - (days * 24 * 60 * 60 * 1000));
}

export const getDateBeforeLocale = (days: number) => {
    var now = new Date();
    return new Date(now.getTime() - (days * 24 * 60 * 60 * 1000) - now.getTimezoneOffset()*60*1000);
}

export const convertUTCDateToLocalDate = (dateString: string) => {
    if(!dateString) return '';
    let date = new Date(dateString);
    let newDate = new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
    return `${newDate.getDate()}/${newDate.getMonth()+1}/${newDate.getFullYear()} : ${formatTime(newDate.toString())}`;
}

export const convertUTCDateToLocalDateMMDDYY = (dateString: string) => {
    if(!dateString) return '';
    let date = new Date(dateString);
    let newDate = new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
    return `${newDate.getMonth()+1}/${newDate.getDate()}/${newDate.getFullYear()} : ${formatTime(newDate.toString())}`;
}

export const getPastDateByDaysAgo = (days:number, withTime: boolean = false) => {
    let dateTime = moment().subtract(days, 'days');
    if(withTime) {
        return dateTime.format('YYYY-MM-DDTHH:mm')
    }
    return dateTime.format('YYYY-MM-DD')
}

export const areDatesEqual = (date1: Moment, date2: Moment) => date1.isSame(date2, 'day');

export const daysSinceStartOfMonth = () => {
    const today = new Date();
    return today.getDate() - 1;
}

export const daysSinceLastMonday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    return (dayOfWeek + 6) % 7;
}

export const getDaysInPreviousMonth = () => {
    return new Date(new Date().getFullYear(), new Date().getMonth(), 0).getDate();
}

export const generateUniqueId = () => {
    return `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}

export const isFirstDateGreaterThanSecond = (date1: string, date2: string) => {
    return new Date(date1) > new Date(date2)
}

export const formatMsToHHMMSS = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

export const timeAgo = (dateString: string) => {
    if(!dateString) return {
        agoString: "",
        type: "",
        value: 0
    };
    const date = new Date(dateString + "Z");
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMinutes < 60) {
        return {
            agoString: `(${diffMinutes} minutes ago)`,
            type: "minute",
            value: diffMinutes
        };
    } else if (diffHours < 24) {
        return {
            agoString: `(${diffHours} hours ago)`,
            type: "hour",
            value: diffHours
        };
    } else {
        return {
            agoString: `(${diffDays} days ago)`,
            type: "day",
            value: diffDays
        };
    }
}
